/**
 * Registers the two-column, leftColumn, and rightColumn directives with the given AngularJS module.
 */
export default function registerTwocolumnsDirective(angular) {
    angular.module("assessmentFrontendDirectives")
        .directive('twocolumns', function () {
            return {
                restrict: 'EA',
                transclude: {
                    'left': '?left',
                    'right': '?right'
                },
                template: `
                    <div class="row">
                        <div class="col-md-10">
                            <div class="main-content-wrapper" ng-transclude="left"></div>
                        </div>
                        <div class="col-md-2">
                            <div ng-transclude="right"></div>
                        </div>
                    </div>
                `,
                scope: false
            };
        })
        .directive('left', function () {
            return {
                restrict: 'E',
                transclude: true,
                template: `<div ng-transclude></div>`
            };
        })
        .directive('right', function () {
            return {
                restrict: 'E',
                transclude: true,
                template: `<div ng-transclude></div>`
            };
        });
}